@if (home) {
<div class="home-layout">
  <section class="hero-shell">
    <div class="hero-grid">
      <div class="hero-copy">
        <p class="kicker">Paulo Veras · Systems Analyst</p>
        <h1>{{ home.titulo }}</h1>
        <div [innerHtml]="home.textoPrincipal" class="hero-text"></div>
        <div class="hero-actions">
          <a [routerLink]="temas?.length ? ['/artigos', temas[0].id] : ['/link']" class="hero-btn hero-btn-primary">Ver
            artigos</a>
          <a [routerLink]="['/contato']" class="hero-btn hero-btn-outline">Entre em contato</a>
        </div>
        <div class="hero-badges">
          <span>20+ anos de carreira</span>
          <span>.NET 8</span>
          <span>Angular</span>
        </div>
      </div>
      <aside class="hero-panel">
        <img src="imagens/{{ home.foto }}" alt="Foto de perfil de Paulo Veras" />
        <h3>Analista de Sistemas</h3>
        <div [innerHtml]="home.textoSobre" class="pb-5"></div>
        <hr />
        <h3>Contato e redes</h3>
        <div class="social-links">
          <a href="{{ home.linkedin }}" target="_blank" rel="noreferrer noopener">LinkedIn</a>
          <a href="{{ home.gitHub }}" target="_blank" rel="noreferrer noopener">GitHub</a>
          <a href="{{ home.twitter }}" target="_blank" rel="noreferrer noopener">Twitter</a>
          <a [routerLink]="['/contato']">Enviar mensagem</a>
        </div>
      </aside>
    </div>
  </section>

  <section class="content-shell">
    <article class="content-block soft-glass">
      <h2>Ferramentas que eu uso todo dia</h2>
      <p>Uma selecao das tecnologias com as quais trabalho e estudo continuamente.</p>
      <div class="stack-grid">
        <div class="stack-card">
          <h3>Backend</h3>
          <p>C#, .NET 8, ASP.NET Core, Web APIs e arquitetura em camadas.</p>
        </div>
        <div class="stack-card">
          <h3>Frontend</h3>
          <p>Angular, TypeScript, Bootstrap e interfaces responsivas.</p>
        </div>
        <div class="stack-card">
          <h3>Dados</h3>
          <p>SQL Server, modelagem relacional e consultas otimizadas.</p>
        </div>
        <div class="stack-card">
          <h3>Cloud</h3>
          <p>Azure, IIS, ambientes Linux, CI/CD e boas praticas de deploy.</p>
        </div>
      </div>
    </article>

    <article class="content-block split-layout">
      <div class="soft-glass">
        <h2>O que ando aprendendo</h2>
        @if (materia) {
        <div class="article-feature">
          <p class="article-meta">
            {{ materia.data | date: 'MMM / yyyy' }} · {{ materia.tema.nome }}
          </p>
          <h3>{{ materia.titulo }}</h3>
          <div [innerHtml]="materia.texto" class="article-text"></div>
        </div>
        }
      </div>

      <aside class="right-column">
        <div class="soft-glass compact-block">
          <h3>Pesquisar conteudo</h3>
          <form (ngSubmit)="submitForm()" [formGroup]="formSearch" class="search-form">
            <input type="text" placeholder="Pesquisar..." formControlName="termo" />
            <button type="submit" aria-label="Pesquisar">
              <i class="fas fa-search"></i>
            </button>
          </form>
        </div>

        <div class="soft-glass compact-block">
          <h3>Artigos por tema</h3>
          @if (!isTemaLoaded) {
          <div class="loading-inline">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
          }
          @if (isTemaLoaded) {
          @for (tema of temas; track tema) {
          <div class="topic-group">
            <h4>{{ tema.nome }}</h4>
            <ul>
              <list-materia-datas [temaId]="tema.id"></list-materia-datas>
            </ul>
          </div>
          }
          }
        </div>
      </aside>
    </article>
  </section>
</div>
}